import React, {Component, Fragment} from 'react';
import {updateAccountPreferences} from '../api';
import If from "./if";
import styled from 'styled-components';
import {Button, InlineError, Card, Icon} from "@shopify/polaris";
import AsyncEvent from "@stak-digital/async-event";
import ResponsiveSquare from './responsive-square';

const GridList = styled.ul`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	margin: 0;
	padding: 0;
`;

const TemplatePreview = styled.li`
	width: calc(${100 / 3}% - 25px);
	display: flex;
	margin-bottom: 10px;
	border: 3px solid transparent;
	position: relative;
	
	${props => props.isActive && `
		border-color: #007ace;
	`}
	
	img {
		max-width: 100%;
		max-height: 100%;
	}
	
	button {
		flex: 1 0;
		appearance: none;
		border: none;
		background: #ddd;
		padding: 0;
		
		&:after {
			content: "";
			display: block;
			padding-bottom: 100%;
		}
	}
`;

const IconContainer = styled.div`
    position: absolute;
    z-index: 2;
    bottom: 0;
    right: 0;
    
    &:before {
        content: "";
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 0 25px 25px;
        border-color: transparent transparent #007ace transparent;
        position: absolute;
        bottom: 0;
        right: 0;
    }
    
    > span {
        svg {
            width: 20px;
            height: 20px;
            position: absolute;
            bottom: -3px;
            right: -3px;
            width: 20px !important;
            height: 20px !important; 
        }
    }
`;

export default class TemplatesList extends Component {
    state = {
        updateSelectedTemplateEvent: new AsyncEvent(),
        newSelectedTemplate: null,
    };

    handleNewTemplateSelected = async (event) => {
        const templateId = event.target.value;

        this.setState({
            newSelectedTemplate: templateId
        });
    };

    handleNewTemplateConfirmed = async () => {
        const newTemplateData = this.props.templates.find(
            template => template.link === this.state.newSelectedTemplate
        );

        this.setState(state => {
            return {
                ...state,
                updateSelectedTemplateEvent: state.updateSelectedTemplateEvent.markAsExecuting()
            };
        });

        try {
            await updateAccountPreferences({template: this.state.newSelectedTemplate});

            this.setState(state => {
                return {
                    ...state,
                    newSelectedTemplate: null,
                    updateSelectedTemplateEvent: state.updateSelectedTemplateEvent.resolve()
                };
            });
        } catch (e) {
            this.setState(state => {
                return {
                    ...state,
                    updateSelectedTemplateEvent: state.updateSelectedTemplateEvent.reject(e)
                };
            });
        }

        this.props.onNewTemplateSelected(newTemplateData);
    };

    renderTemplatePreview = template => {
        let isActive = false;

        if (this.props.selectedTemplate) {
            isActive = this.state.newSelectedTemplate
                ? template.link === this.state.newSelectedTemplate
                : template.link === this.props.selectedTemplate.link;
        }

		return (
			<TemplatePreview
				key={template.link}
				isActive={isActive}
			>
				<button
					onClick={this.handleNewTemplateSelected}
					value={template.link}
					type="button"
					style={{
						backgroundColor: '#ddd',
						backgroundImage: `url(${template.thumb})`,
						backgroundRepeat: 'no-repeat',
						backgroundSize: 'cover'
					}}
				/>
                {isActive && (
                    <IconContainer>
						<Icon
							source="checkmark"
                            color="white"
						/>
                    </IconContainer>
                )}
			</TemplatePreview>
		);
	};

    render() {
        const {selectedTemplate, templates} = this.props;

        return (
            <div>
                {selectedTemplate ? (
                    <Card.Section title={'Selected Template'}>
                        <ResponsiveSquare
                            style={{
                                backgroundColor: '#ddd',
                                backgroundImage: `url(${selectedTemplate ? selectedTemplate.thumb : ''})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                marginBottom: 15
                            }}
                        />
                    </Card.Section>
                ) : (
                    <Card.Section title={'Selected Template'}>
                        <p>
                            You have not selected a template yet, so no Zings
                            will be sent. Please select a template from the ones available below.
                        </p>
                    </Card.Section>
                )}
                <Card.Section title={`Choose ${selectedTemplate ? 'a new' : 'a'} template`}>
                    <GridList>
                        {templates.map(this.renderTemplatePreview)}
                    </GridList>
                    {this.state.newSelectedTemplate && (
                        <Fragment>
                            <Button
                                onClick={this.handleNewTemplateConfirmed}
                                loading={this.state.updateSelectedTemplateEvent.isExecuting}
                            >
                                Update
                            </Button>
                            <If condition={this.state.updateSelectedTemplateEvent.status === 'error'}>
                                {() => (
                                    <InlineError
                                        fieldID="selected_template"
                                        message="Something went wrong, please try again."
                                    />
                                )}
                            </If>
                        </Fragment>
                    )}
                </Card.Section>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/template-list.js